/** 하나로그, 태깅을 위한 store */
export default {
  state: () => ({
    customerId: null,
    customerNumber: null,
  }),
  mutations: {
    SET_CUSTOMER_INFO(state, data) {
      state.customerId = data.customerId
      state.customerNumber = data.customerNumber
    },
  },
}
